import pathOr from 'ramda/src/pathOr'
import { moduleIdProp } from 'root/src/client/logic/route/lenses'
import { formModuleLenses } from 'root/src/client/logic/form/lenses'
import moduleDescriptions from 'root/src/shared/descriptions/modules'

const { viewTitle } = formModuleLenses

export default (state, props) => {
	const title = pathOr(
		viewTitle(moduleIdProp(props), moduleDescriptions),
		['stepFormCurrentPage', 'title'],
		props,
	)
	return title
		? typeof title === 'function'
			? title(state, props)
			: title
		: undefined
}
